import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from '../../../common_components/Header';
import AdminHeader from '../../../common_components/admin_module_header';
// import Drawer from '../../common_components/Drawer';
import { lastSubmitAdd_action } from '../../../actions/last_submit_action'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withRouter } from '../../../utils/withRouter';
import moment from 'moment';
import Modal from "react-modal";
import Loader from '../../../utils/Loader'
import { getPaymentOrderDetails_action, insertHotelEnquiryDownload_action } from '../../../actions/registration_action'
import { clearSessionStorage, countryActionId, toastError, toastSuccess, countryIWithCodeActionId, DOC_BASE_URL, link_BASE_URL } from '../../../utils/constants'
import Pagination from '../../../utils/pagination'
import { useEffect, useState } from 'react';
import { useNavigate, Link } from "react-router-dom";
import { fill_action } from '../../../actions/fillCombo_action'
// import StepHeader from './stepHeader'
import Footer from '../../../common_components/Footer';
// import {
//  approveWaiveOff_action
// } from "../../../actions/exhibitor_module_actions/exhibitor_exit_pass_action/exhibitor_exit_pass_action";
import { getDamageList_action, getDamageDetails_action } from "../../../actions/admin_module_action/account_exit_pass_action/account_exit_pass_action";

class DamageList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            scripts: [],


            ExhRegistrationNo: '',
            CompanyName: '',
            vendorName: '',
            damageList: [],
            currentPage: 1,
            damagePop: false,

            exhNo: '',
            exhname: '',
            damageRemark: '',
            damageMarked: '',
            DamageDate: '',
            imgarr: [],
        }

        this.getDamageList = this.getDamageList.bind(this)
        this.getDamageDetails = this.getDamageDetails.bind(this)
        this.onPreviousClick = this.onPreviousClick.bind(this)
        // this.getPaymentDetails = this.getPaymentDetails.bind(this)
        // this.downloadFileHotelEnquiry = this.downloadFileHotelEnquiry.bind(this)
    }



    componentWillUnmount() {
        const { isClickValidation, scripts, isNavForm } = this.state
        if (!isNavForm) {
            sessionStorage.clear()
            // if (!isClickValidation) {
            //     window.location.replace('http://localhost:3000/#/');
            // }

            if (scripts) {
                scripts.forEach((script) => {
                    if (script.parentNode) {
                        script.parentNode.removeChild(script);
                    }
                });
            }
        }
    }



    componentDidMount() {
        console.log('session : ', sessionStorage);
        this.getDamageList()
        // window.history.pushState(null, "", window.location.href);
        // window.onpopstate = function () {
        //     window.history.pushState(null, "", window.location.href);
        // };
        // if (sessionStorage.getItem('sessionExhibitionID') != null) {

        //     this.callGAScripts()
        //     var exhno = this.props.location.state != null && this.props.location.state != "" && this.props.location.state.ExhRegistrationNo != " " ? this.props.location.state.ExhRegistrationNo : ''
        //     // Exhibition From Date
        //     const dateString = sessionStorage.getItem('exhibitionDateFrom');
        //     const isFromDateValid = moment(dateString, "DD/MM/YYYY", true).isValid()
        //     const dateStringMoment = isFromDateValid ? moment.utc(dateString, "DD/MM/YYYY").format('DD MMMM YYYY') : moment.utc(dateString).format('DD MMMM YYYY')
        //     const dateObject = new Date(dateStringMoment);
        //     const fromDay = dateObject.getDate();
        //     const fromMonth = dateObject.toLocaleString('default', { month: 'long' });
        //     const fromYear = dateObject.getFullYear();
        //     const ExfromDate = `${fromDay} ${fromMonth} ${fromYear}`;
        //     console.log('dateString', dateString)
        //     console.log('dateStringMoment', dateStringMoment)
        //     console.log('dateObject', dateObject)

        //     // Exhibition to Date
        //     const dateString1 = sessionStorage.getItem('exhibitionDateTo');
        //     const isToDateValid = moment(dateString1, "DD/MM/YYYY", true).isValid()
        //     const dateString1Moment = isToDateValid ? moment.utc(dateString1, "DD/MM/YYYY").format('DD MMMM YYYY') : moment.utc(dateString1).format('DD MMMM YYYY')
        //     const dateObject1 = new Date(dateString1Moment);
        //     const toDay = dateObject1.getDate();
        //     const toMonth = dateObject1.toLocaleString('default', { month: 'long' });
        //     const toYear = dateObject1.getFullYear();
        //     const ExtoDate = `${toDay} ${toMonth} ${toYear}`;
        //     this.setState({
        //         geturl: this.props.location.state != null && this.props.location.state != "" && this.props.location.state.geturl != " " ? this.props.location.state.geturl : '',
        //         is_partner: this.props.location.state != null && this.props.location.state != "" && this.props.location.state.is_partner != " " ? this.props.location.state.is_partner : '',
        //         exhibitionAdd: this.props.location.state != null && this.props.location.state != "" && this.props.location.state.exhibitionAdd != " " ? this.props.location.state.exhibitionAdd : '',
        //         exhibitionName: this.props.location.state != null && this.props.location.state != "" && this.props.location.state.exhibitionName != " " ? this.props.location.state.exhibitionName : '',
        //         ExhRegistrationNo: exhno,
        //         fromDate: this.props.location.state != null && this.props.location.state != "" && this.props.location.state.fromDate != " " ? this.props.location.state.fromDate : (sessionStorage.getItem('exhibitionDateFrom') != null && sessionStorage.getItem('exhibitionDateFrom') != '') ? ExfromDate : '',
        //         toDate: this.props.location.state != null && this.props.location.state != "" && this.props.location.state.toDate != " " ? this.props.location.state.toDate : (sessionStorage.getItem('exhibitionDateTo') != null && sessionStorage.getItem('exhibitionDateTo') != '') ? ExtoDate : '',
        //         SSRLink: sessionStorage.getItem('SSRLink')
        //     }, () => {
        //         sessionStorage.setItem('is_partner', this.props.location.state != null && this.props.location.state != "" && this.props.location.state.is_partner != " " ? this.props.location.state.is_partner : null)
        //     })
        //     this.getPaymentDetails()
        // }
    }

    async callGAScripts() {
        const { scripts } = this.state
        const script1 = document.createElement("script");
        script1.async = true;
        script1.src = "https://www.googletagmanager.com/gtag/js?id=G-1QY8MXN64V";
        document.head.appendChild(script1);
        scripts.push(script1); // Store reference

        const script2 = document.createElement("script");
        script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-1QY8MXN64V');
    `;
        document.head.appendChild(script2);
        scripts.push(script2)
    }

    onPreviousClick(e) {
        const { isClickValidation } = this.state
        e.preventDefault();
        var url = sessionStorage.getItem('sessionExhMailWebsite')
        this.setState({ isClickValidation: true }, () => {
            sessionStorage.clear()
            const win = window.location.replace(url)
            // const win = window.open(this.state.geturl, '_blank');
            if (win != null) {
                win.focus();
            }
        })
    }


    getDamageList() {
        const { isLoading, DDreturnListArr, hallList, zoneList, currentPage, HallId, ZoneId, ExhRegistrationNo, CompanyName, vendorName, DDno, DDdate } = this.state
        // this.setState({ isLoading: true })
        this.props.getDamageList_action(ExhRegistrationNo, CompanyName, vendorName)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ damageList: data.data[0] })
                    this.setState({ isLoading: false })
                } else {
                    toastError('Something went wrong...')
                    this.setState({ isLoading: false })

                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    getDamageDetails(exhid, venid, no, name, DamageMarkedBy, DamageDate) {
        const { isLoading, DDreturnListArr, hallList, zoneList, currentPage, HallId, ZoneId, ExhRegistrationNo, CompanyName, vendorName, DDno, DDdate } = this.state
        this.setState({ isLoading: true })
        this.props.getDamageDetails_action('', 3, exhid, venid)
            .then((data) => {
                if (data.error != 1) {
                    // this.setState({ damageList: data.data[0] })
                    var list = data.data[0]
                    var docList = []
                    for (var i = 0; i < list.length; i++) {
                        docList.push(`${DOC_BASE_URL + list[i].DocumentPath}`)
                    }
                    this.setState({
                        isLoading: false, damagePop: true, exhNo: no, exhname: name, damageRemark: data.data[0][0].Remark, imgarr: docList, damageMarked: DamageMarkedBy,
                        DamageDate: DamageDate
                    })
                } else {
                    toastError('Something went wrong...')
                    this.setState({ isLoading: false })

                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    renderList(currentRecords) {
        const { isLoading, DDreturnListArr, hallList, zoneList, currentPage, HallId, ZoneId, ExhRegistrationNo, CompanyName, vendorName, DDno, DDdate } = this.state
        return (
            <>
                <table class="table table-bordered table-striped">
                    <thead class="table-light">
                        <tr>
                            <th>Exhibitor Details</th>
                            <th >Contractor/ Service Partner Details</th>
                            <th class="text-center">Damage Marked By</th>
                            <th class="text-center">Damage Date</th>
                            <th style={{ width: '75px' }} class="text-center">View</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentRecords.length > 0 ? currentRecords.map(item => (
                            <tr>
                                <td><span style={{ fontWeight: "600" }}>{item['ExhRegistrationNo'] != '' ? item['ExhRegistrationNo'] : ''}</span> {item['ExhRegistrationNo'] != null && item['ExhRegistrationNo'] != '' ? <br /> : ''}{item['ExhibitorName']}</td>
                                <td class="vendor p-1 ">
                                    {<div style={{ lineHeight: '14px' }}>
                                        <span class="my-1 mt-0  ha-view-com fw-bold"><i class="fa fa-solid text-dark fa-building"></i>&nbsp;
                                            {item.CompanyName} </span>
                                        <br />
                                        {item['PersonName'] != null && <span class="mt-0  ha-view-com" style={{ fontSize: "11px" }}><i class="fa fa-solid fa-user text-primary"></i>&nbsp; {item['PersonName']} </span>}
                                        <br />
                                        {item['MobileNo'] != null && <span class="mt-1" style={{ fontSize: "11px" }}> <i class="fa fa-solid fa-phone text-danger"></i>
                                            &nbsp; {item['MobileNo']}  </span>}
                                        <br />
                                        {item['PrimaryEmail'] != null && <span style={{ fontSize: "11px" }}> <i class="fa fa-solid text-cyan fa-envelope"></i>
                                            &nbsp; {item['PrimaryEmail']} </span>}
                                        <br />
                                    </div>}
                                </td>
                                <td class="text-center ">{item.DamageMarkedBy}</td>
                                <td class="text-center ">{moment(item.DamageDate).format('DD/MM/YYYY')}</td>
                                <td class="text-center">
                                    {/* <a href="dd-return-entry"> */}
                                    <i style={{ cursor: 'pointer' }} class="bi bi-eye text-primary" onClick={() => this.getDamageDetails(item['ExhRegistrationID'], item['VendorID'], item.ExhRegistrationNo, item.ExhibitorName, item.DamageMarkedBy, item.DamageDate)}></i>
                                    {/* </a> */}
                                </td>
                            </tr>
                        )) : <tr>
                            <td colSpan={12} className="text-center">Record not found</td>
                        </tr>}
                    </tbody>
                </table >
            </>
        )
    }

    // Update Current Page
    updateItem(item) {
        const { accountEntryPassList } = this.state
        this.setState({ currentPage: item });
    }
    clearValue() {
        this.setState({
            ExhRegistrationNo: '', CompanyName: '', vendorName: ''
        })
        setTimeout(() => {
            this.getDamageList()
        }, 100);
    }

    // handleUpdate(exhid, venid) {
    //     this.setState({

    //     })
    // }

    // onFilterClick(mode) {
    //     const { isLoading, ExitNo, HallId, ZoneId, isOpen, mainList, QrCodeImg, ExhRegistrationNo, ContractorCompanyName, CompanyName, hallList, zoneList, accountExitPassList, currentPage, dismantlePop, tcomp, tpending } = this.state
    //     console.log("pppp")
    //     var templist
    //     if (mode == 0) {
    //         templist = mainList.filter(item => item.Status == 'Returned')
    //     } else {
    //         templist = mainList.filter(item => item.Status != 'Returned')
    //     }
    //     this.setState({ DDreturnListArr: templist })
    // }


    render() {
        const { isLoading, geturl, damagePop, SSRLink, imgarr, is_partner, CompanyName, vendorName, damageList, currentPage, exhibitionAdd, fromDate, toDate, exhibitionName, ExhRegistrationNo } = this.state
        console.log(sessionStorage.getItem('SSRLink'))
        const recordsPerPage = 10;
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = damageList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(damageList.length / recordsPerPage)
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (null)}
                <ToastContainer />
                {/* <!-- PAGE --> */}
                {/* <Header /> */}
                {!sessionStorage.getItem('sessionExhibitionID') ? (<AdminHeader isSteper={false} />) : (<Header />)}
                {/* <!-- CONTAINER --> */}
                <div >
                    {/* <StepHeader /> */}

                    {/* <!-- ROW-1 --> {geturl}*/}
                    <div
                        className="main-content app-content mt-0"
                        style={{ backgroundColor: "#ececec", height: '100vh' }}
                    >
                        <div className="side-app">
                            <div className="main-container container-fluid top-form-name">
                                <div className="row m-0">
                                    <div className="breadcrumb-scroll-fixed">
                                        <h6 className="mb-0 p-2 text-white">Damage List</h6>
                                    </div>
                                </div>

                                <div className="admin-top-space p-2">
                                    <div className="row m-0">
                                        {/* <div className="col-xl-2">
                                            <label className="col-form-label">DD No.</label>
                                            <input type="text" className="form-control form-control-sm w-100"
                                                value={DDno}
                                                onChange={(e) => this.setState({ DDno: e.target.value })} />
                                        </div> */}
                                        {/* <div className="col-xl-2">
                                            <label className="col-form-label">DD Date</label>
                                            <DatePicker className="form-control"
                                                dateFormat="dd-MM-yyyy"
                                                selected={DDdate ? new Date(DDdate) : ''}
                                                onChange={(e) => this.setState({ DDdate: e })}
                                                peekNextMonth
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                placeholderText="dd-mm-yyyy"
                                            />
                                        </div> */}

                                        {/* <div className="col-xl-2">
                                            <label className="col-form-label">Hall</label>
                                            <select
                                                className="form-control"
                                                value={HallId}
                                                onChange={(e) => this.setState({ HallId: e.target.value })}
                                            >
                                                <option value="">Select</option>
                                                {hallList.map(data => (
                                                    <option key={data.HallId} value={data.HallId}>{data.HallName}</option>
                                                ))}
                                            </select>
                                        </div> */}

                                        {/* <div className="col-xl-2">
                                            <label className="col-form-label">Zone</label>
                                            <select
                                                className="form-control"
                                                value={ZoneId}
                                                onChange={(e) => this.setState({ ZoneId: e.target.value })}
                                            >
                                                <option value="">Select</option>
                                                {zoneList.map(data => (
                                                    <option key={data.ZoneID} value={data.ZoneID}>{data.Zone}</option>
                                                ))}
                                            </select>
                                        </div> */}

                                        <div className="col-xl-2">
                                            <label className="col-form-label">Exhibitor Reg. No.</label>
                                            <input type="text" className="form-control form-control-sm w-100"
                                                value={ExhRegistrationNo}
                                                onChange={(e) => this.setState({ ExhRegistrationNo: e.target.value })} />
                                        </div>

                                        <div className="col-xl-2">
                                            <label className="col-form-label">Exhibitor</label>
                                            <input type="text" className="form-control form-control-sm w-100"
                                                value={CompanyName}
                                                onChange={(e) => this.setState({ CompanyName: e.target.value })} />
                                        </div>

                                        <div className="col-xl-2">
                                            <label className="col-form-label">Service Partner</label>
                                            <input type="text" className="form-control form-control-sm w-100"
                                                value={vendorName}
                                                onChange={(e) => this.setState({ vendorName: e.target.value })} />
                                        </div>
                                        <div className="col-xl-2 text-left">
                                            <label></label>

                                            <div
                                                className="d-flex gap-2 mt-3"
                                                role="group"
                                                aria-label="Basic example"
                                                style={{ float: "left" }}
                                            >
                                                <button
                                                    type="button"
                                                    className="btn btn-aqua"
                                                    onClick={() => this.getDDreturnListArr()}
                                                >
                                                    Search
                                                </button>

                                                <button
                                                    type="button"
                                                    className="btn btn-gray"
                                                    onClick={() => this.clearValue()}
                                                >
                                                    Clear
                                                </button>
                                            </div>
                                        </div>


                                    </div>
                                </div>

                                <div className="row m-0">
                                    <div class="table-freeze mt-1" style={{ maxHeight: "calc(100vh - 300px)", overflow: 'auto' }}>
                                        {this.renderList(currentRecords)}
                                    </div>
                                </div>
                                <div class="d-flex justify-content-between align-items-center p-0 mt-3">
                                    <div class="text-muted page-count">
                                        Page <strong>{currentPage}</strong> of <strong>{nPages}</strong>
                                    </div>
                                    {
                                        damageList.length > 0 ?
                                            <Pagination
                                                nPages={nPages}
                                                currentPage={currentPage}
                                                setCurrentPage={this.updateItem}
                                            /> : <></>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
                <Footer />
                {/* <!-- CONTAINER END --> */}
                <Modal
                    isOpen={this.state.damagePop} onRequestClose={() => this.setState({ damagePop: false })}
                >
                    {/* <div className="modal-dialog">
                                          <div className="modal-content confirm-logout">
                                              <div class="modal-header p-2">
                                                  <h5 class="modal-title">Additional Furniture</h5>
                                                  <button type="button " class="close pop-close" data-dismiss="modal" onClick={() => this.setState({ isOpen: false })} ><span aria-hidden="true" class="pop-cancel">&times;</span></button>
                                              </div>
                                              <div>
                                              </div>
                  
                                          </div>
                                      </div> */}

                    {/* <div className="modal-dialog modal-xl modal-dialog-centered" style={{ marginLeft: '325px', marginTop: '60px' }}> */}

                    <div class="modal-dialog modal-xl modal-dialog-centered" style={{ fontSize: 'larger' }}>
                        <div className="modal-content shadow-lg border-0 rounded-4">
                            <div class="modal-header">
                                <h5 class="modal-title" style={{ fontSize: "16px" }}>Damaged Record</h5>
                                <button type="button" class="btn-close btn-close-white text-white" onClick={() => this.setState({ damagePop: false })} ></button>
                            </div>
                            <div class="modal-body">
                                <div >
                                    <strong style={{ fontSize: 'x-large' }}>{this.state.exhNo}</strong><br />
                                    <strong>{this.state.exhname}</strong><br /><br />
                                </div>
                                <div>
                                    Damage Marked By: <strong>{this.state.damageMarked}</strong><br />
                                    Damage Marked Date: <strong>{moment(this.state.DamageDate).format('DD/MM/YYYY')}</strong><br /><br />
                                </div>
                                <div>
                                    Remark: <strong>{this.state.damageRemark}</strong><br />
                                </div>
                                <div>
                                    Images<br />
                                    {imgarr.length > 0 && imgarr.map(item => (
                                        <img
                                            onClick={() => window.open(item, "_blank", "noopener,noreferrer")}
                                            src={item}
                                            style={{ margin: '2px', cursor: 'pointer' }}
                                            alt="Preview"
                                            width="200"
                                            height="200"
                                        />
                                    ))}
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-gray bg-secondary" onClick={() => this.setState({ damagePop: false })}>Cancel</button>
                            </div>
                        </div>
                    </div>
                </Modal>
            </>
        );
    }
}

export default withRouter(connect(null, {
    // lastSubmitAdd_action, getPaymentOrderDetails_action, insertHotelEnquiryDownload_action
    getDamageList_action, getDamageDetails_action
})(DamageList));

